import Button from "./ui/Button";
import { elapsed, fecha_actual } from "../hooks/elapsed";
import { useState } from "react";
import { Spinner } from "./Spinner";

export interface TramitesProps {
  data: any;
  accion: any;
  texto_accion: string;
  ejecutivos: any;
  cargando: boolean;
  action_cargando: boolean;
}

export const TablaBuscaPolizaComponent = ({
  data,
  accion,
  texto_accion,
  ejecutivos = [],
  cargando = false,
  action_cargando = false,
}: TramitesProps) => {
  return (
    <div className="block w-full overflow-x-auto">
      <table className="w-full border-collapse items-center bg-transparent ">
        <thead>
          <tr>
            <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
              Nombre Contratante
            </th>
            <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
              Nombre Asegurado
            </th>
            <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
              Fecha Nacimiento
            </th>
            <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
              Cuenta
            </th>
            <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
              Estatus Póliza
            </th>
            <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
              Monto Asegurado
            </th>
            <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
              Recibo ATM
            </th>
            <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left text-center align-middle text-xs font-semibold uppercase text-white">
              ...
            </th>
          </tr>
        </thead>
        <tbody className="dark:divide-gray-199 divide-y divide-gray-200">
          {data &&
            data.map((d: any) => {
              return (
                <tr key={d.ATMID} className="border-b-secondary-ultra-light">
                  <th className="text-blueGray-700 whitespace-nowrap border-l-0 border-r-0 border-t-0 p-2 px-2 text-left align-middle text-xs ">
                    <span className="flex flex-col">
                      <span>{d.contratante_nombre}</span>
                    </span>
                  </th>
                  <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 text-xs">
                    <span className="flex flex-col">
                      <span>{d.asegurado_nombre}</span>
                    </span>
                  </td>
                  <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 px-6 text-xs">
                    <span className="flex flex-col">
                      <span>{d.Fecha_Nac}</span>
                    </span>
                  </td>
                  <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 px-6 text-xs">
                    <span className="flex flex-col">
                      <span>{d.cuenta}</span>
                    </span>
                  </td>
                  <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 px-6 text-xs">
                    <span className="flex flex-col">
                      <span>{d.IDStatus === 2 ? "CANCELADA" : "ACTIVA"}</span>
                    </span>
                  </td>
                  <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 px-6 text-xs">
                    <span className="flex flex-col">
                      <span>{d.SA_Importe}</span>
                    </span>
                  </td>
                  <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 px-6 text-xs">
                    <span className="flex flex-col">
                      <span>{d.Promass}</span>
                    </span>
                  </td>
                  <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 px-6 text-xs">
                    {!action_cargando && (
                      <span className="flex flex-col">
                        <Button
                          onClick={() => {
                            accion(d.ATMID, d.fc_tipo_base);
                          }}
                        >
                          Ver Mas
                        </Button>
                      </span>
                    )}
                    {action_cargando && (
                      <span className="flex flex-col">
                        <Spinner />
                      </span>
                    )}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};
